<template>
  <div class="actions">
    <v-spacer class="mt-4"></v-spacer>
    <v-btn depressed class="mr-4" @click="undo">
      {{ $gettext("Annulla") }}
    </v-btn>
    <v-btn depressed class="mr-4" color="primary" @click="submit">
      {{ $gettext("Salva") }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    undo() {
      this.$emit("undo")
    },
    submit() {
      this.$emit("submit")
    },
  },
}
</script>

<style>
@media print {
  .actions {
    display: none;
  }
}
</style>
